module.exports = __webpack_public_path__ + "img/standard-icon4.074e134.svg";